import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ShortMessage as ShortMessage, ShortMessageStatus } from '../../../../models/dashboard';

@Component({
  selector: 'short-message',
  templateUrl: './short-message.component.html',
  styleUrls: ['./short-message.component.scss']
})
export class ShortMessageComponent {
  @Input()
  public message: ShortMessage;

  @Input()
  public editable: boolean;

  @Output()
  public removeMessage = new EventEmitter<ShortMessage>();

  constructor() { }

  public onDelete() {
    this.removeMessage.emit(this.message);
  }

  public hasWarning(message: ShortMessage): boolean {
    return message.status === ShortMessageStatus.Warning;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer-home/short-message/short-message.component.ts